import React, { useState } from 'react';
import logo from '../img/vana png.png';
import '../style/login.css';
import HomeIcon from '@mui/icons-material/Home';
import DOMPurify from 'dompurify';
import api from '../api/api';
import { Link, useNavigate } from 'react-router-dom';
import Alert_Modals from '../components/Alert_Modals';
import { setUser } from '../Store/userSlice';
import { useDispatch } from 'react-redux';

function Signuppage() {
    const [formData, setData] = useState({
        fullName:'',
        phone: '',
        email: '',
        password: '',
        userType: 'Individual', // Default value
        tin:null,
        companyName:null
        });
    const showModal= Alert_Modals();
    const navigate= useNavigate();
    const dispatch= useDispatch();

    // Function for stripping harmful tags
    const sanitizeInput = (input) => {
        return DOMPurify.sanitize(input);
    };

    // Handle change in input fields
    const onHandelChange = (e) => {
        setData((prev) => ({
            ...prev,
            [e.target.name]: sanitizeInput(e.target.value),
        }));
    };

    // Handle form submit
    const handelSubmit =async (e) => {
        e.preventDefault();
        const bodyData= new FormData();
        for (const key in formData){
            if(formData[key]!==null)
                {
            bodyData.append(key,formData[key]);
                }
        }
       try {
    
        const response= await api.post("/users/create-account/",bodyData);
            if( response.data.msg=="created successfully"){
                localStorage.setItem('Token',JSON.stringify(response.data.token));
                const res= await api.post(`/users/${response.data._id}`);
                showModal.showAlert("Account Created Successfully",'success',"center").then(()=>{
                    localStorage.setItem('account',JSON.stringify(res.data.user));
                    dispatch( setUser(res.data.user));
                    navigate('/');
                })
                
            }
        
       } catch (error) {
        console.log(error)
        showModal.showAlert(error.response.data.msg,'error','top-end').then();
       }
    };

    return (
        <div className="container p-0">
            <div className="row">
                <div className="col-sm-12">
                    <div className="mt-5 col-sm-12 col-md-7 p-0 mb-3 rounded shadow mx-auto">
                        <div className="row py-3 rounded">
                            <div className="col-sm-12 d-flex justify-content-center">
                                <img src={logo} loading='lazy' className="login-logo" alt="vana_logo" />
                            </div>
                            <div className="col-sm-12 col-md-8 mx-auto order-2 order-md-1 py-5 px-3 d-flex flex-column align-items-center">
                                <div className="d-flex w-100 justify-content-between px-3 align-items-center">
                                    <div>
                                        <h3 className="fw-bold my-auto login-header-text">Sign up</h3>
                                    </div>
                                    <div className="rounded-circle shadow p-2 login-homeicon-container">
                                        <Link to="/" className="text-decoration-none">
                                            <HomeIcon className="login-homeicon" />
                                        </Link>
                                    </div>
                                </div>
                                <div className="w-100 mt-3 p-lg-4">
                                    <form onSubmit={handelSubmit} className="mt-3">
                                        <div className="form-floating mb-4 mt-3">
                                            <input
                                                type="text"
                                                onChange={onHandelChange}
                                                className="form-control login-inputs"
                                                id="fullName"
                                                placeholder="Enter your name"
                                                name="fullName"
                                                value={formData.fullName}
                                            />
                                            <label htmlFor="fullName" className="login-form-label text-start w-100">
                                                Name
                                            </label>
                                        </div>
                                        <div className="form-floating mb-4 mt-3">
                                            <input
                                                type="email"
                                                onChange={onHandelChange}
                                                className="form-control login-inputs"
                                                id="email"
                                                placeholder="Enter email"
                                                name="email"
                                                value={formData.email}
                                            />
                                            <label htmlFor="email" className="login-form-label text-start w-100">
                                                Email
                                            </label>
                                        </div>
                                        <div className="form-floating mt-4 mb-3">
                                            <input
                                                type="password"
                                                onChange={onHandelChange}
                                                className="form-control login-inputs"
                                                id="password"
                                                placeholder="Enter password"
                                                name="password"
                                                value={formData.password}
                                            />
                                            <label htmlFor="pwd" className="login-form-label w-100 text-start">
                                                Password
                                            </label>
                                        </div>
                                        <div className="form-floating mb-4 mt-3">
                                            <input
                                                type="tel"
                                                onChange={onHandelChange}
                                                className="form-control login-inputs"
                                                id="phone"
                                                placeholder="Enter phone number"
                                                name="phone"
                                                value={formData.phone}
                                            />
                                            <label htmlFor="phonenumber" className="login-form-label text-start w-100">
                                                phoneNumber
                                            </label>
                                        </div>
                                        <div className="row">
                                            <label className="login-form-label text-start mb-3 w-100">Representing</label>
                                            <div className="col">
                                                <div className="form-check">
                                                    <input
                                                        type="radio"
                                                        className="form-check-input"
                                                        onChange={onHandelChange}
                                                        id="radio1"
                                                        name="userType"
                                                        value="Individual"
                                                        checked={formData.userType === 'Individual'}
                                                    />
                                                    <label className="form-check-label fw-bold" htmlFor="radio1">
                                                        Individual
                                                    </label>
                                                </div>
                                            </div>
                                            <div className="col">
                                                <div className="form-check">
                                                    <input
                                                        type="radio"
                                                        className="form-check-input"
                                                        onChange={onHandelChange}
                                                        id="radio2"
                                                        name="userType"
                                                        value="Company"
                                                        checked={formData.userType === 'Company'}
                                                    />
                                                    <label className="form-check-label fw-bold" htmlFor="radio2">
                                                        Company
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        {formData.userType=="Company" && 
                                        <>
                                        <div className="form-floating mb-4 mt-3">
                                            <input
                                                type="text"
                                                onChange={onHandelChange}
                                                className="form-control login-inputs"
                                                id="tin"
                                                placeholder="Enter tin"
                                                name="tin"
                                                required
                                                value={formData.tin}
                                            />
                                            <label htmlFor="tin"  className="login-form-label text-start w-100">
                                                Tin
                                            </label>
                                        </div><div className="form-floating mb-4 mt-3">
                                            <input
                                                type="text"
                                                onChange={onHandelChange}
                                                className="form-control login-inputs"
                                                id="companyName"
                                                placeholder="Enter tin"
                                                name="companyName"
                                                required
                                                value={formData.companyName}
                                            />
                                            <label htmlFor="tin" className="login-form-label text-start w-100">
                                                company name
                                            </label>
                                        </div>
                                        </>
                                        }
                                        <div className="d-grid mt-4">
                                            <button type="submit" className="p-2 btn btn-primary btn-block login-button">
                                                Sign up
                                            </button>
                                        </div>
                                        <div className='mt-4'>
                                            <h6 className='text text-center text-secondary'>if you already have an account <Link to="/login"><span>Sign In</span></Link></h6>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Signuppage;
